import { render, staticRenderFns } from "./TsSectionTabs.vue?vue&type=template&id=71161d70"
import script from "./TsSectionTabs.vue?vue&type=script&lang=ts"
export * from "./TsSectionTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports